import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AdministrationComponent} from './administration.component';
import {CoreModule} from '../core.module';
import {SharedModule} from '../shared/shared.module';
import {CountryModule} from './countries/country.module';
import {ExpertiseAreaModule} from './expertise-areas/expertise-area.module';
import {StandardTitleModule} from './standard-titles/standard-title.module';
import {OrganizationTypeModule} from './organization-types/organization-type.module';
import {OrganizationSubtypeModule} from './organization-subtypes/organization-subtype.module';

@NgModule({
  imports: [
    CommonModule, CoreModule, SharedModule,
    ExpertiseAreaModule,
    StandardTitleModule,
    CountryModule,
    OrganizationTypeModule,
    OrganizationSubtypeModule
  ],
  declarations: [
    AdministrationComponent
  ],
  exports: [
    AdministrationComponent
  ]
})
export class AdministrationModule {
}
